<template>
  <div class="edit">
    <validation-observer ref="observer">
      <v-container
        fluid
        class="px-0"
        v-for="(row, index) in filterFields(fieldsRow)"
        :key="index"
      >
        <div class="text-h5 mb-3" v-if="row.title">{{ row.title }}</div>

        <v-row>
          <v-col
            v-for="field in row.fields"
            :key="field.id"
            v-bind="field.colProps || row.colsProp"
            class="py-0"
          >
            <validation-provider
              v-slot="{ errors }"
              :name="field.id"
              :rules="field.rules"
            >
              <component
                :is="field.component"
                v-model="localValue[field.id]"
                :label="field.label"
                :error-messages="getErrorMessage(errors, fieldErrors[field.id])"
                v-bind="field.props"
                outlined
                :id="field.id"
              />
            </validation-provider>
          </v-col>
        </v-row>
      </v-container>
    </validation-observer>
  </div>
</template>

<script>
import { Entity, Validation } from "@/mixins";
import { VTextField, VTextarea } from "vuetify/lib";
import { DatePicker, FileInputSelect } from "@/components/UI";

export default {
  name: "edit-news",

  mixins: [Entity, Validation],

  components: {
    VTextField,
    VTextarea,
    FileInputSelect,
    DatePicker,
  },

  computed: {
    fieldsRow() {
      return [
        {
          // Свойства для всех колонок в строке
          colsProp: {
            cols: 12,
          },

          fields: [
            {
              id: "title",
              label: "Заголовок",
              component: "VTextField",
              rules: "required",
            },
            {
              id: "description",
              label: "Описание",
              component: "VTextarea",
            },
            {
              id: "image",
              label: "Превью",
              component: "FileInputSelect",
              props: {
                clearable: true,
              },
            },
            {
              id: "active_from",
              label: "Начало активности",
              component: "DatePicker",
              rules: "required|beforeOrEqual:active_to,Окончание активности",
              colProps: {
                lg: 6,
              },
            },
            {
              id: "active_to",
              label: "Окончание активности",
              component: "DatePicker",
              rules: "required|afterOrEqual:active_from,Начало активности",
              colProps: {
                lg: 6,
              },
            },
          ],
        },
      ];
    },
  },
};
</script>
